import React, { Component } from 'react';

import Separation from './../atoms/Separation.jsx'
import TitleSectionMaster from './../atoms/TitleSectionMaster.jsx'

import FontAwesome from './../scripts/FontAwesome.jsx'


import PresentationCard from './../molecules/PresentationCard.jsx'

import Sentence from './../atoms/Sentence.jsx'
import WhoIam from './../atoms/WhoIam.jsx'
import WhoIdo from './../atoms/WhoIdo.jsx'

import TextDescriptionSectionMaster from './../atoms/TextDescriptionSectionMaster.jsx'
import ButtonSectionMaster from '../atoms/ButtonSectionMaster.jsx'

import SectionSocialMediaCards from './../organisms/SectionSocialMediaCards.jsx'
import PresentationExperencieAndLenguages from '../molecules/PresentationExperencieAndLenguages.jsx';
import BannerPromotional from '../molecules/BannerPromotional.jsx';
import GoUp from '../scripts/GoUp.js';

class PageMaster extends Component {

    componentDidMount() {
        GoUp()
    }

    render() {
        return(
            <>
                < BannerPromotional />
                <main class="main">

		            <section class="container-master-about-me">
                        < PresentationCard />

                    {/* TWO COLUMN */}
                    <div class="container-about-two">

                        {/* Presentation */}
                        < Sentence />
                        < WhoIam />
                        < WhoIdo />
                        < PresentationExperencieAndLenguages />

                        < Separation />

                        {/* Last Projects */}
                        < TitleSectionMaster title="Ultimos proyectos" />
                        < TextDescriptionSectionMaster textDescriptionSectionMaster="Los proyectos son una prueba de argumentar lo que sé, argumenta la experiencia que tengo en esta áera, de tal manera si quieres saber en proyectos reales y no reales lo que puedo hacer, solo ve mis proyectos."/>
                        < ButtonSectionMaster link="/ultimos-proyectos" text="Ultimos Proyectos" />

                        < Separation />

                        {/* Social Media */}
                        < TitleSectionMaster title="Redes Sociales" />
                        < SectionSocialMediaCards />

                        < Separation />

                        {/* Blog */}
                        < TitleSectionMaster title="Blog" />
                        < TextDescriptionSectionMaster textDescriptionSectionMaster="Si quieres conocer mas de las experiencias técnicas y sociales o un blog de tecnologia diferente, te invito a ver el blog." />
                        < ButtonSectionMaster link="/blog" text="Blog" />
		            </div>
                    </section>
                </main>

        < FontAwesome />
        </>
        )
    }
}

export default PageMaster;
